<template lang="pug">
    // Root element of PhotoSwipe. Must have class pswp.
    .pswp(tabindex='-1' role='dialog' aria-hidden='true')
        //
            Background of PhotoSwipe.
            It's a separate element as animating opacity is faster than rgba().
        .pswp__bg
        // Slides wrapper with overflow:hidden.
        .pswp__scroll-wrap
            //
                Container that holds slides.
                PhotoSwipe keeps only 3 of them in the DOM to save memory.
                Don't modify these 3 pswp__item elements, data is added later on.
            .pswp__container
                .pswp__item
                .pswp__item
                .pswp__item
            // Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed.
            .pswp__ui.pswp__ui--hidden
                .pswp__top-bar
                    // Controls are self-explanatory. Order can be changed.
                    .pswp__counter
                    button.pswp__button.pswp__button--close(title="Schließen (Esc)")
                    button.pswp__button.pswp__button--share(title="Teilen")
                    button.pswp__button.pswp__button--fs(title="Vollbild")
                    button.pswp__button.pswp__button--zoom(title="Zoom in/out")
                    // Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR
                    // element will get class pswp__preloader--active when preloader is running
                    .pswp__preloader
                        .pswp__preloader__icn
                            .pswp__preloader__cut
                                .pswp__preloader__donut
                .pswp__share-modal.pswp__share-modal--hidden.pswp__single-tap
                    .pswp__share-tooltip
                button.pswp__button.pswp__button--arrow--left(title="Vorheriges Bild (Pfleil nach links)")
                button.pswp__button.pswp__button--arrow--right(title="Nächstes Bild (Pfeil nach rechts)")
                .pswp__caption
                    .pswp__caption__center
</template>

<script>
    import 'photoswipe/dist/photoswipe.css'
    import 'photoswipe/dist/default-skin/default-skin.css'

    import PhotoSwipe from 'photoswipe/dist/photoswipe'
    import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default'

    export default {
        methods: {
            open (event, index, items, options = {
                // captionEl: false,
                fullscreenEl: true,
                history: false,
                shareEl: false,
                tapToClose: true,
                closeOnScroll: false,
                closeOnVerticalDrag: false,
                preload: [2, 3],
            }) {
                const opts = Object.assign({
                    index: index,
                    getThumbBoundsFn (index) {
                        // const thumbnail = document.querySelectorAll('.preview-img-list .preview-img-item')[index]
                        const thumbnail = event.target.closest('.preview-img-list').querySelectorAll('.preview-img-item')[index]
                        const pageYScroll = window.pageYOffset
                            || document.documentElement.scrollTop
                            || document.body.scrollTop
                            || 0
                        const rect = thumbnail.getBoundingClientRect()
                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width
                        }
                    }
                }, options)

                this.photoswipe = new PhotoSwipe(this.$el, PhotoSwipeDefaultUI, items, opts)
                this.photoswipe.init()
            },

            close () {
                this.photoswipe.close()
            }
        }
    }
</script>


<style lang="sass">
    .pswp__bg
        background: rgba(0,0,0,0.9)
        backdrop-filter: blur(10px)

    .pswp__button--arrow--left:before, .pswp__button--arrow--right:before
        background-color: transparent
</style>
